import { render, staticRenderFns } from "./PadFooter.vue?vue&type=template&id=7c90708c&"
import script from "./PadFooter.vue?vue&type=script&lang=js&"
export * from "./PadFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports